import {ISSUE_VIEWER_CACHE_TTL_MS} from '@github-ui/preheat-issues-manager/issue-viewer-storage-key'
import {queryOptions} from '@github-ui/react-query'
import type {createServerPersistedQueryPersister} from '@github-ui/react-query-persister'
import {ConvertToDiscussionDialogServerQuery} from '@github-ui/server-persisted-queries'
import type {ConvertToDiscussionDialogServerQueryQuery} from '@github-ui/server-persisted-queries/types/ConvertToDiscussionDialogServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

import {VALUES} from '../constants/values'

export function convertToDiscussionDialogQueryKey(owner: string, repository: string, number: number) {
  return ['issue-viewer', 'convert-to-discussion-dialog', {owner, repository, number}] as const
}

// Built at module scope so the cached `queryFn` retains only these arguments, not a component's closure scope.
export function convertToDiscussionDialogQueryOptions(
  owner: string,
  repository: string,
  number: number,
  persister: ReturnType<typeof createServerPersistedQueryPersister>,
) {
  return queryOptions({
    queryKey: convertToDiscussionDialogQueryKey(owner, repository, number),
    queryFn: ({signal}) => fetchConvertToDiscussionDialog(owner, repository, number, signal),
    gcTime: ISSUE_VIEWER_CACHE_TTL_MS,
    persister,
  })
}

export async function fetchConvertToDiscussionDialog(
  owner: string,
  repository: string,
  number: number,
  signal?: AbortSignal,
): Promise<ConvertToDiscussionDialogServerQueryQuery> {
  const query = new URLSearchParams({
    queryId: ConvertToDiscussionDialogServerQuery,
    first: String(VALUES.convertToDiscussionCategoriesFirst),
  })
  const response = await reactFetchJSON(
    `/${owner}/${repository}/issues/${number}/convert_to_discussion_dialog.json?${query}`,
    {
      signal,
    },
  )

  if (!response.ok) throw new Error(`Convert to discussion dialog fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: ConvertToDiscussionDialogServerQueryQuery; errors?: unknown[]}
  if (!json.data) throw new Error('Convert to discussion dialog query returned no data')

  return json.data
}
